<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.model.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.model.label.decription')}}
                                </p>

                                <form>
                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.status')}}
                                            </label>
                                            <select v-model="data.status" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option value="ACTIVE">{{$t('string.msg.active')}}</option>
                                                <option value="ARCHIVED">{{$t('string.msg.archived')}}</option>
                                            </select>
                                        </div>

                                        <!-- <div class="form-group col-md-3 text-center">
                                            <br/><br/>
                                            <button v-on:click="confirmArchive" class="text-dark-gray btn btn-warning w-50">{{$t('string.msg.status.archive')}}</button>
                                        </div> -->
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.model.label.type')}}
                                            </label>
                                            <select v-model="data.type" class="form-control" @change="getManufacturer()">
                                                <option value="TRUCK">{{$t('string.msg.model.type.truck')}}</option>
                                                <option value="TRUCK_TRAILER">{{$t('string.msg.model.type.truck-trailer')}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.model.label.fipeCode')}}
                                            </label>
                                            <input type="text" v-model="data.fipeCode" class="form-control" :placeholder="$t('string.msg.model.placeholder.fipeCode')" v-mask="'######-#'">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.manufacturs.label')}}
                                            </label>
                                            <select id="manufacturer" v-model="data.manufacturer" class="form-control"  @change="onChange(data.manufacturer)">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers">{{camelize(item.name).split('ZZZ_').join('')}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.model.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.name" class="form-control" :placeholder="$t('string.msg.model.placeholder.name')">
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                        <button @click="save" class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <List v-on:load-item="selectItem"/>
                    
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtModel';

import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import List from './ListModel';
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();

export default {
  name: 'Family',
  components: {
    Spinner,
    Toast,
    List
  },
  data() {
      return {
        errors: [],
        manufacturers:[],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        data: {
            status: "ACTIVE",
            name: null,
            type:'TRUCK',
            fipeCode:null,
            manufacturer:null,
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
